import { Component, ComponentInterface, Event, EventEmitter, h, Host, JSX, Prop } from '@stencil/core';
import { TRACKING_EVENT_TYPE } from '@usercentrics/cmp-browser-sdk';

import { Events } from '../../constants';
import { BannerLink } from '../../types/BannerLink';

@Component({
  tag: 'cmm-footer-links',
  styleUrl: 'cmm-footer-links.scss',
  shadow: false,
})
export class FooterLinks implements ComponentInterface {
  @Prop() links: Array<BannerLink>;

  @Event({
    eventName: Events.TRACK,
    bubbles: true,
  })
  trackEvent: EventEmitter<TRACKING_EVENT_TYPE>;
  handleClick(_event: MouseEvent, link: BannerLink): void {
    this.trackEvent.emit(link.event);
  }

  public render(): JSX.Element {
    if (!this.links) {
      return false;
    }

    return (
      <Host>
        <footer class="footer-links">
          <ul class="footer-links__list" data-test="footer-links">
            {this.links.map((link, index) => (
              <li key={`link-${index}`}>
                <wb7-link
                  class="footer-links__list__item"
                  href={link.url}
                  variant="standalone"
                  onClick={(event: MouseEvent): void => this.handleClick(event, link)}
                >
                  {link.label}
                </wb7-link>
              </li>
            ))}
          </ul>
        </footer>
      </Host>
    );
  }
}
